<template>
  <div
    class="teamNameLogo"
    :style="{ width: width, '--mixtmt_mixvw': cssDynamicObj.mixvw }"
  >
    <span
      class="country_logo"
      :style="{ width: countryLogoSize[0], height: countryLogoSize[1] }"
    >
      <img :src="countryImg" alt="" />
    </span>
    <span
      class="country-name"
      v-text="_valPerFormatHandler(countryName)"
    ></span>
  </div>
</template>

<script>
// 球员信息
export default {
  name: 'comp_teamNameLogo',
  props: {
    // 必传参数，国家图片
    countryImg: {
      type: String,
      // default: 'https://mms-voice.cdn.bcebos.com/ressync/voiceability/taste/voice_matcher_day.png'
    },
    // 必传参数，国家中文名
    countryName: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: 'calc(7.64vw * var(--mixtmt_mixvw))',
    },
    countryLogoSize: {
      type: Array,
      default: () => {
        return [
          'calc(4.5vw * var(--mixtmt_mixvw))',
          'calc(3vw * var(--mixtmt_mixvw))',
        ] //['4.5vw', '3vw']
      },
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.teamNameLogo {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: calc(7.64vw * var(--mixtmt_mixvw));
  .country_logo {
    position: relative;
    width: calc(4.5vw * var(--mixtmt_mixvw));
    height: calc(3vw * var(--mixtmt_mixvw));
    margin-bottom: calc(1.388vw * var(--mixtmt_mixvw));
    overflow: hidden;
    &::before {
      content: '\20';
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      border: 1px solid var(--mixtmt_greyColor5);
    }
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .country-name {
    font-size: calc(1.11vw * var(--mixtmt_mixvw));
    color: var(--mixtmt_greyColor_main);
    line-height: calc(1.666vw * var(--mixtmt_mixvw));
    vertical-align: top;
    text-align: center;
  }
}
</style>
